import { z } from 'zod';
import { twentyThreeAudioSchema } from '../schema.twenty-three-audio.js';
import { bindUnvalidatableInputMaker } from '../util.make-unvalidatable-input.js';

const makeUnvalidatableInput = bindUnvalidatableInputMaker();
const markWordsAudioInput = makeUnvalidatableInput({
  schema: z.object({
    type: z.literal("Audio"),
    src: z.string(),
    title: z.string().default(""),
    twentyThreeAudio: twentyThreeAudioSchema
  }).transform(it => ({
    ...it,
    id: "audio",
    nodeType: "audio",
    src: it.twentyThreeAudio?.src || it.src
  }))
});

export { markWordsAudioInput };
//# sourceMappingURL=input.audio.js.map
